// import { TransactionItemTypeEnum } from "@repo/core/constants/transactions";
import { TransactionItemProps } from "@repo/core/components/layout/TransactionGroup/TransactionItem/types";
import { TransactionsGroup } from "@repo/core/screens/Transactions/types";
import { TransactionItemModel } from "../services/entities/Transactions";
import { TransactionItemTypeEnum } from "@repo/core/constants/transactions";

export const parseTransactionsByType = (
  transactions: TransactionItemProps[]
) => {
  // let filterTransactions = transactions;

  // filterTransactions = transactions.filter((transaction) => {
  //   return transaction.strTipo !== TransactionItemTypeEnum.PONTUACAO;
  // });

  return transactions;
};

export const groupTransactionsByDate = (
  transactions: TransactionItemProps[]
): TransactionsGroup[] => {
  const grouped: {
    [key: string]: { date: Date; transactions: TransactionItemProps[] };
  } = {};

  const filteredTransactions = parseTransactionsByType(transactions);

  filteredTransactions.forEach((transaction) => {
    const dateKey = transaction?.datData?.split("T")[0] || "";

    if (!grouped[dateKey]) {
      grouped[dateKey] = {
        date: new Date(transaction?.datData || ""),
        transactions: []
      };
    }

    grouped[dateKey].transactions.push(transaction);
  });

  return Object.values(grouped);
};

export const groupTransactionsByAuthorizatonId = (
  transactions: TransactionItemModel[]
) => {
  return transactions.reduce((acc, transaction) => {
    const existingGroup = acc.find(
      (item) => item.lngAutorizacao === transaction.lngAutorizacao
    );

    if (existingGroup) {
      existingGroup.dblValor! += transaction.dblValor!;
    } else {
      acc.push({ ...transaction });
    }

    return acc;
  }, [] as TransactionItemModel[]);
};


export const getTotalSalesValueFromTransactionType = (transactions: TransactionItemModel[], transactionType: TransactionItemTypeEnum) => {
  const totalValue = transactions
    .filter((transaction) => transaction.strTipo === transactionType)
    .reduce((acc, transaction) => acc + transaction.dblValor, 0);

  return totalValue;
}
